import type { z } from 'zod'

export const isZodError = (error: unknown): error is z.ZodError =>
  error
    ? typeof error === 'object' &&
      'errors' in error &&
      Array.isArray(error?.errors)
    : false
